import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { DEFAULT_LOCALE } from '../constants';

export function getLocale(flowAPI: ControllerFlowAPI) {
  const { wixCodeApi } = flowAPI.controllerConfig;
  return wixCodeApi.site.regionalSettings ?? DEFAULT_LOCALE;
}
